<template>
  <table
  :style="cssVars"
  :class="style.borders ? 'bordered' : ''"
  class="styled-table">
    <template >
      <tr class="border-top">
        <td
          class="categ-title extra-pad"
          rowspan="3"
        >
          Patologia Oncológica
        </td>
        <td colspan="8" class="categ-title" style="text-align: center !important;" >
          Causistica
        </td>
      </tr>
      <tr class="border-top" style="text-align: center !important;">
        <td colspan="4" class="categ-title" >
          Tratamento Antineoplástico
        </td>
        <td colspan="4" class="categ-title" style="text-align: center !important;">
          Seguimento Clínico
        </td>
      </tr>
      <tr class="border-top" style="text-align: center !important;">
        <td colspan="2" class="categ-title" >
          Curativo
        </td>
        <td colspan="2" class="categ-title" style="text-align: center !important;">
          Paliativo
        </td>
        <td colspan="2" class="categ-title" >
          Sintomático
        </td>
        <td colspan="2" class="categ-title" style="text-align: center !important;">
          Sobrevivente
        </td>
      </tr>
        <tr v-for="(log, index) in tableValues" :key="index">
          <td class="subcateg-title pl-4">
            <span>{{log.name}}</span>
          </td>
          <td>{{log.curativeCount}}</td>
          <td>{{Math.round(log.curativePercent)}}%</td>
          <td>{{log.palliativeCount}}</td>
          <td>{{Math.round(log.palliativePercent)}}%</td>
          <td>{{log.survivorCount}}</td>
          <td>{{Math.round(log.survivorPercent)}}%</td>
          <td>{{log.symptomsCount}}</td>
          <td>{{Math.round(log.symptomsPercent)}}%</td>
        </tr>
    </template>
    <tr>
      <td>Total</td>
      <td>{{curativeTotal}}</td>
      <td>100%</td>
      <td>{{palliativeTotal}}</td>
      <td>100%</td>
      <td>{{survivorTotal}}</td>
      <td>100%</td>
      <td>{{symptomsTotal}}</td>
      <td>100%</td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    logs: { type: Array },
  },
  data() {
    return {
      curativeTotal: 0,
      palliativeTotal: 0,
      survivorTotal: 0,
      symptomsTotal: 0,
      style: {
        borders: true,
        borderColor: '#cccccc',
        colors: ['#ffffff']
      },
    }
  },
  computed: {
    cssVars() {
      return {
        '--bg-color': this.style.colors[0],
        '--bg-light-color': this.style.colors[0] + 20,
        '--categ-color': this.style.colors[0] + 99,
        '--subcateg-color': this.style.colors[0] + 60,
        '--border-collapse': this.style.borders ? 'collapse' : 'inherit',
        '--border-color': this.style.borderColor,
        '--accent-border-color': this.style.borderColor + 50
      }
    },
    labeledLogs() {
      return this.$store.getters.labeledLogs
    },
    tableValues() {
      let count = {}
      this.labeledLogs.map(log => {
        if(log['diagnosis-ordem-medicos']) {
          const id = log['diagnosis-ordem-medicos'].id
          if(!count[id] && log['antineoplasic-treatment-appointment']) {
            const curativeCount = log['antineoplasic-treatment-appointment'].id === "curative-treatment" ? 1 : 0
            const palliativeCount = log['antineoplasic-treatment-appointment'].id === "palliative-treatment" ? 1 : 0
            count[id] = {
                name: log['diagnosis-ordem-medicos'].text,
                curativeCount: curativeCount,
                palliativeCount: palliativeCount,
                survivorCount: 0,
                symptomsCount: 0,
              }
          } else if (count[id] && log['antineoplasic-treatment-appointment']) {
            log['antineoplasic-treatment-appointment'].id === "curative-treatment" ? count[id].curativeCount++ : ''
            log['antineoplasic-treatment-appointment'].id === "palliative-treatment" ? count[id].palliativeCount++ : ''
          }
          if(!count[id] && log['clinical-follow-up']) {
            const survivorCount = log['clinical-follow-up'].id === "survivor" ? 1 : 0
            const symptomsCount = log['clinical-follow-up'].id === "symptoms" ? 1 : 0
            count[id] = {
                name: log['diagnosis-ordem-medicos'].text,
                curativeCount: 0,
                palliativeCount: 0,
                survivorCount: survivorCount,
                symptomsCount: symptomsCount,
              }
          } else if (count[id] && log['clinical-follow-up']) {
            log['clinical-follow-up'].id === "survivor" ? count[id].survivorCount++ : ''
            log['clinical-follow-up'].id === "symptoms" ? count[id].symptomsCount++ : ''
          }
        } 
      })
      Object.keys(count).map(item => {
        this.curativeTotal = this.curativeTotal + count[item].curativeCount
        this.palliativeTotal = this.palliativeTotal + count[item].palliativeCount
        this.survivorTotal = this.survivorTotal + count[item].survivorCount
        this.symptomsTotal = this.symptomsTotal + count[item].symptomsCount
      })
      Object.keys(count).map(item => {
        count[item].curativePercent = (count[item].curativeCount / this.curativeTotal) * 100
        count[item].palliativePercent = (count[item].palliativeCount / this.palliativeTotal) * 100
        count[item].survivorPercent = (count[item].survivorCount / this.survivorTotal) * 100
        count[item].symptomsPercent = (count[item].symptomsCount / this.survivorTotal) * 100
      })
      return count
    }
  },
  mounted() {
    this.$root.$emit('isTable', true)
    this.$root.$on('selectedStyle', style => {
      this.style = style
    })
  },
}
</script>

<style>
.styled-table tr.border-top{
  border-top: 1px solid var(--border-color);
}
.categ-title.extra-pad {
  padding: 10px 15px;
  width: 100%
}
</style>